export const getDate = (utcTimestamp, options = {}) => {
  if (utcTimestamp) {
    const utcDate = new Date(utcTimestamp);
    const defaultOptions = {
      timeZone: "Asia/Kolkata",
      hour12: true,
      year: "numeric",
      month: "long",
      day: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
    };
    const istOptions = { ...defaultOptions, ...options };
    return new Intl.DateTimeFormat("en-IN", istOptions).format(utcDate);
  }
  return "";
};

export const readingTime = (text) => {
  const wpm = 200;
  const words = text.trim().split(/\s+/).length;
  return Math.ceil(words / wpm);
};